import React, { CSSProperties, Suspense } from 'react';
import styles from '../styles/flag.module.scss';
import { ReactComponent as OlympicFlag } from '@ui-kit/images/olympic-flag.svg';
import classNames from 'classnames';
import { runIfDefined } from '@utils/functions';
import { Loader } from './loader';

export default function Flag(props: {
  countryCode?: string;
  className?: string;
  style?: CSSProperties;
}) {
  const Flag = React.lazy(() =>
    import(`react-flags-select`).then((module) => {
      let flag: any = OlympicFlag;
      runIfDefined(props.countryCode, (code) => {
        runIfDefined(
          module[format(code) as keyof typeof module],
          (m) => (flag = m)
        );
      });
      return { default: flag };
    })
  );

  return (
    <Suspense fallback={<Loader />}>
      <Flag
        className={classNames(styles.flag, props.className)}
        style={props.style}
      />
    </Suspense>
  );
}

const format = (s: string) =>
  s
    .toLowerCase()
    .replace('uk', 'gb') // В игре есть старые записи где uk вместо gb
    .replace(/./, (s) => s.toUpperCase()); // В библиотеке названия флагов в формате Us, Gb итд...
